import {ChangeEvent, InputHTMLAttributes} from 'react';

interface SearchBoxProps extends InputHTMLAttributes<HTMLInputElement> {
  title: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}
const SearchBox = ({title, onChange, ...props}: SearchBoxProps) => {
  return (
    <div className="flex items-center border rounded-md p-2">
      <button className="ml-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          className="w-6 h-6"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </button>
      <input
        type="text"
        placeholder={title}
        className="outline-none px-2 py-1 w-64"
        onChange={onChange}
      />
    </div>
  );
};

export default SearchBox;
